export default "__VITE_ASSET__818758ff__$_?nuxt_component=async__"